<template>
	<el-card shadow="never">
		<div class="header-row" slot="header">
			<div class="title">
				<span style="margin-right: 10px">资产动态</span>
				<!-- <el-tag size="mini" type="danger">最近{{ trends.length || 0 }}条</el-tag> -->
			</div>
			<div
				style="color: #409eff; font-size: 14px; cursor: pointer"
				@click="
					() => {
						this.$router.push('/pages/asset/assetDynamic');
					}
				">
				更多
			</div>
		</div>
		<div class="trends-list">
			<el-empty v-if="!trends.length" description="暂无资产动态" />
			<!-- <el-timeline v-else>
				<el-timeline-item
					v-for="(trend, index) in trends"
					:key="index"
					:timestamp="trend.changeDate"
					placement="top"
					:type="AssetChangeType[trend.changeType] || 'default'">
					<div class="content-wrapper">
						<span class="content">{{ trend.assetName }}</span>
						<el-tag :type="AssetChangeType[trend.changeType] || 'default'" class="tag" size="mini">
							{{ $menu.getLabel('AssetChangeType', trend.changeType) }}
						</el-tag>
					</div>
					<div class="desc">{{ trend.changeDescription }}</div>
				</el-timeline-item>
			</el-timeline> -->
			<div class="times-line" v-else>
				<div class="timeline">
					<div class="timeline-item" v-for="(trend, index) in trends" :key="index" :style="{ '--i': index }">
						<!-- 中间轴 -->
						<div class="axis">
							<div class="dot">
								<!-- <i class="el-icon-edit"></i> -->
								<div class="circle" :class="['ring', `ring-${AssetChangeType[trend.changeType]}`]">
									<div class="inner-circle" :class="['ring', `ring-${AssetChangeType[trend.changeType]}`]"></div>
								</div>
							</div>
							<div class="line" v-if="index !== trends.length - 1"></div>
						</div>

						<!-- 右边内容 -->
						<div class="card">
							<div class="time">
								<div>
									{{ trend.changeDate }}
								</div>
								<el-tag :type="AssetChangeType[trend.changeType] || 'default'" class="tag" size="mini">
									{{ $menu.getLabel('AssetChangeType', trend.changeType) }}
								</el-tag>
							</div>
							<div class="content">{{ trend.assetName }}</div>
							<div class="desc">{{ trend.changeDescription }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</el-card>
</template>

<script>
	// ReceivingMethod
	import { getHomeAssetDynamics } from '@/api/home/homeApi.js';
	import { AssetChangeType } from '@/utils/meunType.js';
	import { getCommunityId } from '@/utils/vc.js';
	import { getAssetChangePage } from '@/api/asset/assetDynamicApi.js';
	export default {
		name: 'AssetTrends',
		data() {
			return {
				AssetChangeType,
				trends: [],
			};
		},
		created() {
			this.fetchTrends();
		},
		methods: {
			async fetchTrends() {
				try {
					const data = await getAssetChangePage({
						communityId: getCommunityId(),
						page: 1,
						size: 7,
					});
					this.trends = data.records || [];
				} catch (error) {
					console.error('Failed to fetch asset trends:', error);
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.el-card__body) {
		height: 300px;
		overflow-y: auto;

		&::-webkit-scrollbar {
			width: 4px;
		}

		&::-webkit-scrollbar-track {
			background: #f1f1f1;
			border-radius: 4px;
		}

		&::-webkit-scrollbar-thumb {
			background: #bfbfbf;
			border-radius: 4px;
			transition: background 0.3s;

			&:hover {
				background: #999;
			}
		}
	}
	.header-row {
		display: flex;
		justify-content: space-between;
		height: 20px;
	}
	.title {
		font-weight: bold;
	}

	.trends-list {
		height: 100%;
	}

	.times-line {
		width: 100%;
		margin-top: 24px;
		display: flex;
		justify-content: flex-end;

		.timeline {
			width: 100%;
		}

		.timeline-item {
			display: grid;
			grid-template-columns: 40px 1fr;
			position: relative;
			margin-bottom: 24px;
			opacity: 0;
			transform: translateY(20px);
			animation: fadeInUp 0.4s ease forwards;
			animation-delay: calc(var(--i) * 0.05s);

			.axis {
				position: relative;
				display: flex;
				justify-content: center;
			}

			.dot {
				// width: 24px;
				// height: 24px;
				// background-color: #fff;
				// color: #409eff;
				// border-radius: 50%;
				// display: flex;
				// align-items: center;
				// justify-content: center;
				z-index: 2;
				transition: all 0.3s;
			}

			.circle {
				width: 24px;
				height: 24px;
				border-radius: 50%;
				// background: #409eff;
				position: relative;
			}

			.inner-circle {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				width: 7px;
				height: 7px;
				border-radius: 50%;
				border: 6px solid #fff;
				// background: #409eff;
			}

			.line {
				position: absolute;
				top: 24px;
				width: 2px;
				height: calc(100% + 24px);
				background: #ebeef5;
			}

			.card {
				transition: all 0.3s;
				border-radius: 10px;
				font-size: 12px;

				.time {
					text-align: left;
					font-weight: 500;
					font-size: 12px;
					color: rgba(0, 0, 0, 0.4);
					display: flex;
					justify-content: space-between;
					align-items: center;
				}

				.content {
					font-weight: bold;
					font-size: 14px;
					color: #191c1e;
					margin: 4px 0;
				}

				.desc {
					font-weight: 400;
					font-size: 12px;
					color: #414755;
				}
			}
		}

		.timeline-item:last-child .line {
			display: none;
		}
	}

	.ring-success {
		background: #67c23a;
	}
	.ring-warning {
		background: #e6a23c;
	}
	.ring-danger {
		background: #f56c6c;
	}
	.ring-info {
		background: #909399;
	}
	.ring-primary,
	.ring-default {
		background: #409eff;
	}

	@keyframes fadeInUp {
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
</style>
